import axios from "axios";
import { PerformanceInput } from "../types/api/Performance";
import { API_URL_PERFORMANCE } from "./Routes";

export async function savePerformance(perf: PerformanceInput) {
  const res = await axios.post(API_URL_PERFORMANCE, {
    performance: perf
  }, { withCredentials: true });
  return res.data as ApiResponse<null>;
}

export async function getPerformances(year: number, month: number) {
  const res = await axios.get(`${API_URL_PERFORMANCE}?year=${year}&month=${month}`, { withCredentials: true });
  return res.data as ApiResponse<any>;
}

export async function deletePerformance(year: number, month: number, day: number) {
  const res = await axios.delete(API_URL_PERFORMANCE, {
    data: {
      performance: { year, month, day }
    },
    withCredentials: true
  });
  return res.data as ApiResponse<null>;
}
